<template>
  <div style="height: 100%;">
    <v-card :scrollable="!unscrollable" style="height: 100%;">
      <v-card-title v-if="!inline">
        {{ report ? 'Pääsuodatin' : 'Uusi suodatus' }}
      </v-card-title>
      <v-card-text :style="`overflow-y: ${unscrollable ? '' : 'scroll'}; ${ inline ? '' : $vuetify.breakpoint.mobile ? 'max-height: calc(100vh - 120px);': 'max-height: 70vh;'}`">
        <div v-if="!report && !inline" style="display: flex; align-items: center;">
          <v-icon v-if="!filter.save">mdi-content-save-off-outline</v-icon>
          <v-icon v-else>mdi-content-save-outline</v-icon>
          <v-switch
            hide-details
            class="mb-3 ml-2"
            label="Tallenna suodatus"
            v-model="filter.save"
          ></v-switch>
        </div>
        <v-expand-transition>
          <!-- ONLY ME  -->
          <div v-if="filter.save && !inline" style="display: flex; align-items: center;">
            <v-icon v-if="!filter.only_me">mdi-account-group-outline</v-icon>
            <v-icon v-else>mdi-account-outline</v-icon>
            <v-switch
              hide-details
              class="mb-3 ml-2"
              label="Näkyy vain minulle"
              v-model="filter.only_me"
            ></v-switch>
          </div>
        </v-expand-transition>
        <v-expand-transition>
          <div class="mb-8" v-if="filter.save && !inline">
            <v-text-field
              hide-details
              v-prevent-keys
              v-show="filter.save"
              class="mt-2"
              v-model="filter.title"
              @input="give_name_error = false"
              placeholder="Suodatuksen nimi"
              :counter="true"
              solo
              :error="true"
            ></v-text-field>
            <div
              style="color: red; margin-top: 5px"
              v-if="give_name_error"
            >
              Anna tallennettavalle suodukselle nimi
            </div>
          </div>
        </v-expand-transition>
        <!-- SUODATUKSEN PARAMETRIT -->
        <div
          style="color: red;"
          v-if="choose_one_error"
          class="mt-2"
        >
          Valitse yksi näistä
        </div>
        <v-row v-if="!inline" class="mt-1" :style="`border: ${choose_one_error ? '1px' : '0px'} solid red; border-radius: 5px;`">
          <v-col
            v-for="(s, i) in filteredSelects"
            :key="i + '-selects'"
            cols="12"
            md="6"
          >
            <template v-if="$vuetify.breakpoint.mobile">
              <v-text-field
                readonly
                :value="getSelectedItemsText(s)"
                :label="s.label"
                :loading="s.loading"
                :append-icon="s.value && s.value.length ? 'mdi-close' : 'mdi-chevron-down'"
                @click:append="s.value && s.value.length ? clearAllSelections(s) : openMobileDialog(s)"
                @click="openMobileDialog(s)"
                class="mb-2"
                dense
                outlined
                hide-details
              ></v-text-field>
              <v-dialog
                v-model="mobileDialogs[s.label]"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                scrollable
                style="z-index: 9999;"
              >
                <v-card class="d-flex flex-column" style="height: 100vh;">
                  <v-card-text class="flex-grow-1">
                    <div class="sticky-search">
                      <v-text-field
                        :id="'search-' + s.label"
                        v-model="mobileSearch[s.label]"
                        prepend-inner-icon="mdi-magnify"
                        label="Hae"
                        single-line
                        hide-details
                        clearable
                        class="mb-4"
                        autofocus
                      ></v-text-field>
                    </div>

                    <v-list class="pt-0">
                      <v-list-item
                        v-for="item in getFilteredItems(s)"
                        :key="item[s.itemValue]"
                        @click="toggleMobileSelection(s, item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>{{ item[s.itemText] }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="isItemSelected(s, item)"
                            color="primary"
                          ></v-checkbox>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-card-actions color="primary" fixed>
                    <v-card-text>{{ s.label }}</v-card-text>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      v-if="s.value && s.value.length"
                      @click="clearAllSelections(s)"
                    >
                      Tyhjennä
                    </v-btn>
                    <v-btn color="primary" text @click="closeMobileDialog(s)">
                      Valmis
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <v-autocomplete
              v-else
              multiple
              chips
              clearable
              closable
              dense
              :no-data-text="s.empty_text"
              :loading="s.loading"
              hide-details
              closable-chips
              :placeholder="s.label"
              :label="s.label"
              :items="s.items"
              :item-text="s.itemText"
              :item-value="s.itemValue"
              :value="s.value"
              @change="handleInput($event, s.callback)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div v-if="!report && !inline" style="max-width: 300px;" class="mt-4">
          <v-select
            :loading="loading_seasons"
            label="Kausi"
            :items="seasons"
            item-text="season_name"
            item-value="id"
            v-model="filter.season"
            hide-details
          ></v-select>
          <div
            style="color: red;"
            v-if="choose_season_error"
            class="mt-2"
          >
            Valitse kausi
          </div>
        </div>

        <div>
          <v-btn
            :disabled="!filterGamesActive"
            class="mt-6"
            @click="chooseVideos = true"
            v-if="leagueId && !report && !initFilter"
            text
          >
            <v-icon>mdi-video-outline</v-icon>
            <span v-if="!filter.game_ids.length && !inline" class="ml-2">
              {{ $vuetify.breakpoint.mobile ? 'Pelit' : 'Suodata pelien mukaan' }}
            </span>
            <v-chip
              label
              :color="filter.game_ids.length > 0 ? 'primary' : ''"
              small
              class="ml-2"
              style="cursor: pointer;"
              text
            >
              {{filter.game_ids.length > 0 ? `Pelit ${filter.game_ids.length}` : 'Kaikki pelit'}}
            </v-chip>
            <v-btn fab class="ml-2" x-small v-if="filter.game_ids.length" @click.stop="filter.game_ids = []">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-btn>
          <ChooseFolderBtn
            v-if="!report && !inline && filter.save && !filter.only_me"
            :value="chosenFolders"
            @input="chosenFolders = $event"
            class="mt-2"
          />
          <div  v-for="(group, index) in filteredFilterItems" :key="index + 'filter-group'">
            <v-divider class="mt-4" />
            <div style="color: black; font-size: 18px;" class="mt-5 mb-3">
              {{ group.title }}
            </div>
            <div
              v-for="(item, i) in filterGroupItems(group.items)"
              :key="i + 'filter-item'"
              class="d-flex mb-3"
              style="flex-wrap: wrap; width: 100%;"
            >
              <FilterBasicItem
                :title="item.title"
                :options="itemOptions(item)"
                v-model="filter[item.model || item.value]"
              ></FilterBasicItem>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="!unscrollable && !inline" absolute>
        <v-btn
          @click="$emit('close'); $emit('close-click');"
        >
          {{ report ? 'Peru muutokset' : $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <div
          style="color: red;"
          v-if="choose_one_error"
          class="mr-3"
        >
          Valitse yksi pääparametri
        </div>
        <div
          style="color: red;"
          v-if="choose_season_error"
          class="mr-3"
        >
          Valitse kausi
        </div>
        <v-btn
          @click="search(false)"
          v-if="filter.save && !$vuetify.breakpoint.mobile"
        >
          <v-icon class="mr-2">mdi-content-save-all-outline</v-icon>
          {{ 'Tallenna & älä hae' }}
        </v-btn>
        <v-btn
          color="primary"
          @click="search(true)"
          :loading="loading"
        >
          <v-icon>mdi-magnify</v-icon>
          <span v-if="!report">
            {{ this.filter.save ? 'tallenna & hae' : 'hae' }}
          </span>
          <span v-else>
            Päivitä suodatin
          </span>
          <v-icon class="ml-2">mdi-keyboard-return</v-icon>
        </v-btn>
      </v-card-actions>
      <div class="d-flex pr-4 pb-4" v-if="unscrollable || inline">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('update', filter)">
          <v-icon class="mr-2">mdi-refresh</v-icon>
          Päivitä
        </v-btn>
      </div>
    </v-card>
    <video-adder
      :getGames="true"
      :leagueId="leagueId"
      :key="tagAdderKey + '1'"
      :show="chooseVideos"
      v-model="filter.game_ids"
      @close="chooseVideos = false"
    >
    </video-adder>
  </div>
</template>

<script>
import VideoAdder from '../video/VideoAdder.vue'
import ChooseFolderBtn from '../folder/ChooseFolderBtn.vue'
import FilterBasicItem from './FilterBasicItem.vue';
import { mapGetters, mapActions } from 'vuex'
import { filter_items, getFilteredFilterItems, filterGroupItems, getFilterItemOptions, getSeasonYear, newRulesApply } from '@/utils/filterItems.js'

export default {
  props: {
    show: Boolean,
    loading: Boolean,
    report: Boolean,
    initFilter: Object,
    unscrollable: Boolean,
    inline: {
      type: Boolean,
      default: false
    }
  },
  shortcuts: {
    enter: function() {
      this.search()
    },
  },
  data: () => ({
    lyonnit: [],
    tulos: [],
    filter: {
      // check = handled in filter events utils/filter/filterEvents.js
      season: null, // check
      save: false, // check
      title: '', // check
      only_me: false, // check
      hitters: [], // check
      runners: [], // check
      upClubs: [], // check
      stadions: [], // check
      spClubs: [], // check
      outfielders: [], // check
      madeOutPlayers: [], // check
      referees: [], // check
      game_ids: [], // check
      vedottu_vaara: ['all'], // check
      vvo: ['all'], // check
      was_wrong: ['all'], // check
      wrong_type: ['all'], // check
      bases_state: ['all'], // check
      marked: ['all'], // check
      hit_outcome: ['all'], // check
      outs: ['all'], // check
      hit_number: ['all'], // check
      vuoropari: ['all'],
      jakso: ['all'],
      lopettava_vuoro: ['all'],
      hit_type: ['all'], // check
      outfield_formation: ['all'], // check
      lapilyonti: ['all'], // check
      tall_pitch: ['all'], // check
      hitter_side: ['all'], // check
      // hit_direction: ['all'], // check
      // nappi_type: ['all'], // check
      kotari: ['all'], // check
      superi: ['all'], // check
      vaara_alla: ['all'], // check
      play_outcome: ['all'], // check
      mark_type: ['all'], // check
      run_measured: ['all'], // check
    },
    videosLoading: false,
    filteringOwnClips: true,
    filterVideosActive: true,
    tagAdderKey: 0,
    chooseTags: false,
    chosenFolders: [],
    chooseVideos: false,
    chooseOwnVideos: false,
    chosenOwnVideos: [],
    filterGamesActive: true,
    rules: {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => (`The email and password you entered don't match`),
    },
    give_name_error: false,
    choose_one_error: false,
    choose_season_error: false,
    mobileDialogs: {},
    mobileSearch: {},
    // filter_items moved to utils/filterItems.js
  }),
  created() {
    if(this.initFilter) {
      this.filter = { ...this.filter, ...this.initFilter }
    }

    this.videosLoading = true

    // Initialize all necessary data
    const initPromises = [];

    if(this.leagueId) {
      this.filteringOwnClips = false
      this.tagAdderKey++

      // Add all initialization promises
      initPromises.push(
        this.initLeaguePlayers({ league_id: this.leagueId }),
        this.initClubs(this.leagueId),
        this.initStadions(this.leagueId),
        this.initReferees(this.leagueId),
        this.initSeasons(this.leagueId).then(seasons => {
          if (seasons && seasons.length > 0) {
            this.filter.season = seasons[0].id;
          }
        })
      );
    }

    // Add game and video initialization if needed
    if(!this.games || !this.games.length) {
      initPromises.push(this.initGames({ league_id: this.leagueId }));
    }
    if(!this.videos || !this.videos.length) {
      initPromises.push(this.initVideos());
    }

    // Execute all initializations
    Promise.all(initPromises)
      .catch(error => {
        console.error('Error initializing CreateFilter data:', error);
        this.error('Virhe tietojen lataamisessa');
      })
      .finally(() => {
        this.videosLoading = false;
      });
  },
  components: {
    VideoAdder,
    ChooseFolderBtn,
    FilterBasicItem
  },
  computed: {
    ...mapGetters('user', [
      'leagueId',
      'user',
      'currentTeamId',
      'currentLeagueName'
    ]),
    ...mapGetters('admin', [
      'games',
      'loading_players',
      'league_players',
      'loading_clubs',
      'clubs',
      'stadions',
      'loading_stadions',
      'referees',
      'loading_referees',
      'seasons',
      'loading_seasons'
    ]),
    ...mapGetters('videos', [
      'videos'
    ]),
    selectedSeasonYear() {
      const season = (this.seasons || []).find(s => s.id === this.filter.season)
      return getSeasonYear(season)
    },
    filteredFilterItems() {
      return getFilteredFilterItems(filter_items, this.currentLeagueName)
        .filter(group => this.filterGroupItems(group.items).length > 0)
    },
    ableToSearch() {
      return !this.loading_seasons && !this.notOneOfTheNeeded
    },
    notOneOfTheNeeded() {
      return !this.filter.hitters.length
        && !this.filter.runners.length
        && !this.filter.upClubs.length
        && !this.filter.spClubs.length
        && !this.filter.stadions.length
        && !this.filter.referees.length
        && !this.filter.outfielders.length
        && !this.filter.madeOutPlayers.length
    },
    filteredSelects() {
      return this.selects.filter(s => {
        if(newRulesApply(this.selectedSeasonYear) && s.removed_2026 && s.removed_2026.includes(this.currentLeagueName)) return false
        if(!s.leagues) return true
        else return s.leagues.includes(this.currentLeagueName) || s.leagues.includes('all')
      })
    },
    selects() {
      return [
        {
          loading: this.loading_players,
          items: this.league_players,
          itemValue: 'id',
          itemText: 'player_name',
          value: this.filter.hitters,
          empty_text: "Pelaajaa ei löydy",
          label: "Lyojät",
          callback: (v) => {
            this.filter.hitters = v
          }
        },
        {
          loading: this.loading_players,
          items: this.league_players,
          itemValue: 'id',
          itemText: 'player_name',
          empty_text: "Pelaajaa ei löydy",
          value: this.filter.runners,
          label: "Kärkietenijät",
          callback: (v) => {
            this.filter.runners = v
          }
        },
        {
          loading: this.loading_players,
          items: this.league_players,
          itemValue: 'id',
          itemText: 'player_name',
          empty_text: "Pelaajaa ei löydy",
          value: this.filter.madeOutPlayers,
          label: "Palon tekijät",
          callback: (v) => {
            this.filter.madeOutPlayers = v
          }
        },
        {
          loading: this.loading_clubs,
          items: this.clubs,
          itemValue: 'id',
          itemText: 'club_name',
          empty_text: "Joukkuetta ei löydy",
          value: this.filter.upClubs,
          label: "UP-joukkueet",
          callback: (v) => {
            this.filter.upClubs = v
          }
        },
        {
          loading: this.loading_clubs,
          items: this.clubs,
          itemValue: 'id',
          itemText: 'club_name',
          empty_text: "Joukkuetta ei löydy",
          value: this.filter.spClubs,
          label: "SP-joukkueet",
          callback: (v) => {
            this.filter.spClubs = v
          }
        },
        {
          loading: this.loading_players,
          items: this.league_players,
          itemValue: 'id',
          itemText: 'player_name',
          leagues: ['msu'],
          removed_2026: ['msu'],
          empty_text: "Pelaajaa ei löydy",
          value: this.filter.outfielders,
          label: "Suorittavat ulkopelaajat",
          callback: (v) => {
            this.filter.outfielders = v
          }
        },
        {
          loading: this.loading_stadions,
          items: this.stadions,
          itemValue: 'id',
          itemText: 'name',
          empty_text: "Stadionia ei löydy",
          value: this.filter.stadions,
          label: "Kentät",
          callback: (v) => {
            this.filter.stadions = v
          }
        },
        {
          loading: this.loading_referees,
          items: this.referees,
          itemValue: 'id',
          itemText: 'name',
          empty_text: "Tuomaria ei löydy",
          value: this.filter.referees,
          label: "Syöttötuomarit",
          callback: (v) => {
            this.filter.referees = v
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions('noti', [
      'error'
    ]),
    ...mapActions('admin', [
      'initGames',
      'initLeaguePlayers',
      'initClubs',
      'initStadions',
      'initReferees',
      'initSeasons'
    ]),
    ...mapActions('videos', [
      'initVideos'
    ]),
    getFilter() {
      return this.filter
    },
    itemIsPro(group) {
      if(!group.pro_leagues) return false
      else return group.pro_leagues.includes(this.currentLeagueName) || group.pro_leagues.includes('all')
    },
    filterGroupItems(items) {
      return filterGroupItems(items, this.currentLeagueName, this.currentTeamId, this.selectedSeasonYear)
    },
    itemOptions(item) {
      return getFilterItemOptions(item, this.currentLeagueName, this.selectedSeasonYear)
    },
    // Clear values of parameters that are not available from the 2026 season onwards,
    // so hidden parameters don't keep filtering events invisibly
    clearRemovedParams() {
      if(!newRulesApply(this.selectedSeasonYear)) return

      filter_items.forEach(group => {
        group.items.forEach(item => {
          const key = item.model || item.value
          if(item.removed_2026 && item.removed_2026.includes(this.currentLeagueName)) {
            this.filter[key] = ['all']
          } else if(Array.isArray(this.filter[key])) {
            // Drop selections whose option no longer exists (e.g. non-Takatilanne formations)
            const allowed = this.itemOptions(item)
              .filter(o => !o.group)
              .map(o => typeof o === 'object' ? o.value : o)
            const cleaned = this.filter[key].filter(v => v === 'all' || allowed.includes(v))
            if(cleaned.length !== this.filter[key].length) {
              this.filter[key] = cleaned.length ? cleaned : ['all']
            }
          }
        })
      })

      if(this.currentLeagueName === 'msu') {
        this.filter.outfielders = []
      }
    },
    handleInput(e, callback) {
      callback(e)
      this.choose_one_error = false
    },
    search(goToFilter = true) {
      if(!this.filter.title && this.filter.save) {
        this.give_name_error = true
        return
      }
      // if(this.notOneOfTheNeeded) {
      //   this.choose_one_error = true
      //   return
      // }
      if(!this.filter.season) {
        this.choose_season_error = true
        return
      }

      let data = {
        ...this.filter,
        league_id: this.leagueId,
        team_id: this.currentTeamId,
        folderIds: this.chosenFolders.map(f => f.id)
      }

      this.track('Filter created', { ...data })

      if(goToFilter) this.$emit('search', data)
      else this.$emit('save', data)
    },
    openMobileDialog(select) {
      this.$set(this.mobileDialogs, select.label, true);
      this.$set(this.mobileSearch, select.label, '');
      // Focus the search input after dialog opens
      this.$nextTick(() => {
        const searchInput = document.querySelector(`#search-${select.label}`);
        if (searchInput) {
          searchInput.focus();
        }
      });
    },
    closeMobileDialog(select) {
      this.$set(this.mobileDialogs, select.label, false);
    },
    toggleMobileSelection(select, item) {
      const currentValue = select.value || [];
      const itemValue = item[select.itemValue];

      if (currentValue.includes(itemValue)) {
        select.callback(currentValue.filter(v => v !== itemValue));
      } else {
        select.callback([...currentValue, itemValue]);
      }
    },
    isItemSelected(select, item) {
      return (select.value || []).includes(item[select.itemValue]);
    },
    getSelectedItemsText(select) {
      if (!select.value || !select.value.length) return 'Ei valittu';
      const selectedItems = select.items.filter(item =>
        select.value.includes(item[select.itemValue])
      );

      // For players/teams, show up to 2 names, then count
      if (select.label === 'Lyojät' || select.label === 'Kärkietenijät' ||
          select.label === 'Palon tekijät' ||
          select.label === 'UP-joukkueet' || select.label === 'SP-joukkueet') {
        if (selectedItems.length === 1) {
          return selectedItems[0][select.itemText];
        }
        if (selectedItems.length === 2) {
          return selectedItems.map(item => item[select.itemText]).join(', ');
        }
        return `${selectedItems[0][select.itemText]}, ${selectedItems[1][select.itemText]} +${selectedItems.length - 2}`;
      }

      // For other fields, show all names if 3 or less, otherwise show count
      if (selectedItems.length <= 3) {
        return selectedItems.map(item => item[select.itemText]).join(', ');
      }
      return `${selectedItems.length} valittu`;
    },
    getFilteredItems(select) {
      const searchTerm = (this.mobileSearch[select.label] || '').toLowerCase();
      if (!searchTerm) return select.items;

      return select.items.filter(item =>
        item[select.itemText].toLowerCase().includes(searchTerm)
      );
    },
    clearAllSelections(select) {
      select.callback([]);
    },
  },
  watch: {
    filter: {
      handler() {
        this.$emit('input', this.filter)
      },
      deep: true
    },
    selectedSeasonYear() {
      this.clearRemovedParams()
    },
  }
}
</script>

<style scoped>
.v-toolbar {
  z-index: 1;
}
.v-btn {
  min-width: 0 !important;
}
.v-text-field {
  cursor: pointer;
}
.v-text-field >>> .v-input__slot {
  cursor: pointer;
}
.sticky-search {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  padding-top: 10px;
  padding-bottom: 10px;
}
.fixed-top {
  position: absolute;
  top: 0;
  z-index: 2;
  background: white;
  padding: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>